import React from 'react';
import { ArrowRight } from 'lucide-react';
import DecorativeImage from '../DecorativeImage';

const benefitsImageMap = {
  'trademark': 'https://images.unsplash.com/photo-1758518726741-6451f7f71348?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'search-registration': 'https://images.unsplash.com/photo-1758518731290-a9eb64660ead?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'clearance': 'https://images.unsplash.com/photo-1728555921674-73a815f71cdd?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'application': 'https://images.unsplash.com/photo-1580893022652-231ff7f2ef41?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'office-actions': 'https://images.unsplash.com/photo-1540647806742-b4ad596a2237?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'monitoring': 'https://images.unsplash.com/photo-1773047747721-f75d546d7290?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'statement-of-use': 'https://images.unsplash.com/photo-1774891937497-96df6a794bd9?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'ownership-change': 'https://images.unsplash.com/photo-1758518730327-98070967caab?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'copyright': 'https://images.unsplash.com/photo-1726203260464-d6a1b25d5412?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'registration': 'https://images.unsplash.com/photo-1666684584998-b39f5133323f?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'assignments': 'https://images.unsplash.com/photo-1627518788331-b3b7fdaa382f?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'litigation': 'https://images.unsplash.com/photo-1709053954126-748172803ae0?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'dmca': 'https://images.unsplash.com/photo-1543148898-0a32d4cf6d1f?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'portfolio': 'https://images.unsplash.com/photo-1762967029968-71e5019ecd5e?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'patent': 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'searches': 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'patent-office-actions': 'https://images.unsplash.com/photo-1758573467057-99f26217b2ae?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'applications': 'https://images.unsplash.com/photo-1766297247287-9bf80d5f8281?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'enforcement': 'https://images.unsplash.com/photo-1766297248047-6ec337099802?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'company': 'https://images.unsplash.com/photo-1753351052046-8c6818304a4f?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'llc': 'https://images.unsplash.com/photo-1753351052046-8c6818304a4f?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'c-corp': 'https://images.unsplash.com/photo-1760426391839-2104ce361957?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  's-corp': 'https://images.unsplash.com/photo-1770134726913-9292449c9144?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'non-profit': 'https://images.unsplash.com/photo-1593113598332-cd288d649433?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85'
};

const SDBenefitsSection = ({ content, onOpenModal, serviceSlug }) => {
  if (!content.benefits || content.benefits.length === 0) return null;

  const category = serviceSlug || 'trademark';
  const image = benefitsImageMap[category] || benefitsImageMap['trademark'];

  return (
    <section className="py-24 bg-white" data-testid="sd-benefits-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left — Content */}
          <div data-testid="sd-benefits-content">
            <p className="eyebrow mb-4">Why Choose Us</p>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter leading-tight mb-6">
              Why Choose Our {content.title}?
            </h2>
            <p className="font-body text-base text-[#4A5D53] leading-relaxed mb-8">
              {content.benefits.slice(0, 3).map(b => typeof b === 'string' ? b : b.desc).join('. ')}. Our expert attorneys ensure every step is handled with precision and care.
            </p>
            <button
              onClick={() => onOpenModal?.(`Benefits - ${content.title}`)}
              className="bg-[#C85A40] hover:bg-[#A64730] text-white font-body font-medium px-8 py-4 rounded-full transition-colors flex items-center gap-2"
              data-testid="sd-benefits-cta-button"
            >
              Register Your Trademark
              <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
            </button>
          </div>

          {/* Right — Image */}
          <div data-testid="sd-benefits-image">
            <DecorativeImage src={image} alt={`${content.title} professional services`} />
          </div>

        </div>
      </div>
    </section>
  );
};

export default SDBenefitsSection;
